import WithLayout from "@components/HOC/withLayout";
import styles from "./LandingPage.module.scss";
import { LandingHeader } from "../../components/LandingHeader/LandingHeader";
import { RecentHashrateCard } from "../../components/RecentHashrateCard/RecentHashrateCard";
import { VideoReviews } from "../../components/VideoReviews/VideoReviews";
import { BenefitsGrid } from "../../components/BenefitsGrid/BenefitsGrid";
import { SubscribeCard } from "../../components/SubscribeCard/SubscribeCard";
import { ContactUsCard } from "../../components/ContactUsCard/ContactUsCard";
import { LandingFooter } from "../../components/LandingFooter/LandingFooter";
import { LandingAuthCard } from "../../components/LandingAuthCard/LandingAuthCard";

function LandingPage() {
  return (
    <section className={styles.page} data-testid="landing-page">
      <LandingHeader />
      <div className={styles.content}>
        <section className={styles.hero} data-testid="landing-hero">
          <RecentHashrateCard />
          <aside className={styles.authShell}>
            <LandingAuthCard />
          </aside>
        </section>
        <div data-testid="landing-video-reviews">
          <VideoReviews />
        </div>
        <div data-testid="landing-benefits">
          <BenefitsGrid />
        </div>
        <section className={styles.formsSection} data-testid="landing-forms">
          <div className={styles.formColumn}>
            <SubscribeCard />
          </div>
          <div className={styles.formColumn}>
            <ContactUsCard />
          </div>
        </section>
      </div>
      <div data-testid="landing-footer">
        <LandingFooter />
      </div>
    </section>
  );
}

export default WithLayout(LandingPage);
